import { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

/**
 * Hook to track unread message counts across all clients (for internal users)
 * or their own client thread (for employer contacts). Polls every 20s.
 *
 * Returns: { total, byClient, refresh }
 */
export default function useUnreadMessages(enabled = true) {
  const [total, setTotal] = useState(0);
  const [byClient, setByClient] = useState({});

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const data = await api.messages.unreadCounts();
      setTotal(data?.total || 0);
      setByClient(data?.byClient || {});
    } catch (err) {
      // Silently swallow — unauth, offline, etc.
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    refresh();
    const t = setInterval(refresh, 20000);
    return () => clearInterval(t);
  }, [enabled, refresh]);

  return { total, byClient, refresh };
}
